import { computed, Injectable, signal } from '@angular/core';
import { IUserData } from '../../models';
import { IHttpResponse } from '@bashaquerizwan/azaadi-packages';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private _loggedInUser = signal<IUserData | null>(
    localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')!).tUser : null
  );
  public readonly isLoggedIn = computed(() => !!this._loggedInUser());

  public readonly loggedInUser = this._loggedInUser.asReadonly();

  setLoggedInUser(user: IUserData | null) {
    this._loggedInUser.set(user);
  }
}
